import { Tab, TabAccordion } from '@dfh-corp-sites/ui/components/Accordion'
import React, { useState } from 'react'

import { SanityRoleBasedContent } from '../../graphql/gatsby'
import { setAnalyticsEvent } from '../../lib/analytics/state'
import { useSanityRoleBasedContent } from '../../lib/sanity/hooks/useSanityRoleBasedContent'
import { LinkFragment } from '../../lib/sanity/link'
import { isNotNull } from '../../utils/collectionTools'
import SanityLink, { NormalizedSanityLinkTagged } from '../global/SanityLink'
import BodyPortableText from '../sanity-page/BodyPortableText'

const setAnalyticsEventOnClick = (
  ctaTitle: string,
  tabTitle: string,
  accordionTitle: string,
  link: NormalizedSanityLinkTagged,
) => {
  setAnalyticsEvent({
    _key: `Tab:${tabTitle}-Button-${ctaTitle}`,
    event: 'select_content',
    content_type: 'accordion',
    item_id: `Tab:${tabTitle}-Button-${ctaTitle}`,
    title: accordionTitle || '',
    label_text: ctaTitle,
    link_destination: link._tag === 'Normalized' ? link.href ?? undefined : link._tag,
    tab_text: tabTitle,
    module_name: 'AccordionSection',
  })
}

export const AccordionSection = ({
  title,
  subtitle,
  tabs,
  roleBasedContent,
}: {
  title?: string
  subtitle?: string
  tabs?: Tab[]
  roleBasedContent: SanityRoleBasedContent
}) => {
  const [activeTab, setActiveTab] = useState('item-0')
  const { shouldDisplay } = useSanityRoleBasedContent({ roleBasedContent })

  if (!shouldDisplay) {
    return null
  }

  const processedTabs = tabs?.filter(isNotNull).map((tab: Tab) => ({
    tabTitle: tab.tabTitle || '',
    tabSubtitle: tab.tabSubtitle || undefined,
    content: tab.content ? <BodyPortableText blocks={tab.content} /> : undefined,
    buttonInstructions: tab.buttonInstructions || undefined,
    ctaLinks: tab.ctaLinks?.map((cta) => ({
      title: cta.title || '',
      link: cta.link,
    })),
  }))

  return (
    <TabAccordion
      title={title || ''}
      subtitle={subtitle || ''}
      tabs={processedTabs || []}
      activeTab={activeTab}
      setActiveTab={(value: string | undefined) => value && setActiveTab(value)}
      renderLink={({ tab, text, href }) => (
        <SanityLink
          to={href as LinkFragment}
          onClick={(_e, normalized) =>
            setAnalyticsEventOnClick(text, tab.tabTitle ?? '', title || '', normalized)
          }
        >
          {text}
        </SanityLink>
      )}
    />
  )
}

export default AccordionSection
